@if (currentLanguage === 'de') {

  <h2 mat-dialog-title>Disclaimer / Rechtliche Hinweise</h2>
  <mat-dialog-content>
    <p>Willkommen auf der Website der Dr. Blumer&Partner Asset-Management (nachfolgend «B&P» genannt). Bitte lesen
      Sie die nachfolgenden Bedingungen – sie sind auf Veranlassung unserer Rechtsberater entstanden – sorgfältig
      durch.
      Mit dem Zugriff auf diese Website und ihre Seiten (nachfolgend «Dr. Blumer-Website» genannt) erklären Sie, dass
      Sie
      die folgenden Benutzungsbedingungen und rechtlichen Informationen im Zusammenhang mit der Dr. Blumer-Website
      verstanden haben und anerkennen. Wenn Sie mit den nachfolgenden Bedingungen nicht einverstanden sind,
      unterlassen Sie bitte den Zugriff auf die Dr. Blumer-Website.</p>

    <h3 class="pt-4">Benutzungsbedingungen und rechtliche Informationen</h3>

    <h3 class="pt-4">Lokale gesetzliche Einschränkungen</h3>
    <p>Ausländische Rechtsordnungen können die Publikation der Dr. Blumer-Website oder die Möglichkeit des Zugriffs
      auf
      die
      Dr. Blumer-Website verbieten. Personen, welche solchen Einschränkungen unterliegen, dürfen die Dr.
      Blumer-Website
      daher nicht besuchen. Einschränkungen gelten insbesondere für Bürger der Vereinigten Staaten von Amerika
      (U.S.A.)
      und Grossbritanniens (UK) und für Personen, die in den U.S.A. oder UK ihren Wohnsitz haben.</p>

    <h3 class="pt-4">Rechte an der Dr. Blumer-Website</h3>
    <p>Der gesamte Inhalt der Dr. Blumer-Website ist urheberrechtlich geschützt (alle Rechte vorbehalten). Das
      Herunterladen oder Ausdrucken einzelner Seiten und/oder Teilbereiche der Dr. Blumer-Website ist gestattet,
      sofern
      weder die Copyrightvermerke noch andere gesetzlich geschützten Bezeichnungen entfernt werden. Wenn Sie Software
      oder
      Daten von der Dr. Blumer-Website herunterladen oder auf andere Weise vervielfältigen, bleiben sämtliche
      Eigentumsrechte bei der B&P. Kein Bestandteil der Dr. Blumer-Website ist so konzipiert, dass dadurch eine Lizenz
      oder ein Recht zur Nutzung eines Bildes, einer eingetragenen Marke oder eines Logos eingeräumt wird. Durch ein
      Herunterladen oder ein Kopieren der Dr. Blumer-Website werden Ihnen keinerlei Rechte im Hinblick auf die
      Software
      oder Elemente auf der Dr. Blumer-Website übertragen. Die B&P behält sich sämtliche Rechte (insbesondere Urheber-
      und
      Markenrechte) hinsichtlich aller Elemente auf der Dr. Blumer-Website vor. Das (vollständige oder teilweise)
      Reproduzieren, Übermitteln (elektronisch oder mit anderen Mitteln), Modifizieren, Verknüpfen oder Benutzen der
      Dr.
      Blumer-Website für öffentliche oder kommerzielle Zwecke ist ohne vorherige schriftliche Zustimmung der B&P
      untersagt.</p>

    <h3 class="pt-4">Keine Zusicherungen und Garantien</h3>
    <p>Sämtliche in der Dr. Blumer-Website enthaltenen Aussagen und Informationen wurden von der Dr. Blumer&Partner
      Gruppe
      oder Dritten zum Zeitpunkt der Veröffentlichung sorgfältig recherchiert und geprüft. Für Richtigkeit,
      Vollständigkeit und Aktualität können jedoch weder die B&P noch Dritte eine explizite bzw. implizite Zusicherung
      oder Garantie (einschliesslich Haftung) abgeben. Die B&P kann auch keine Zusicherung dafür abgeben, dass die
      Aussagen und Informationen nicht durch technische Störungen (Übermittlungsfehler, technische Mängel,
      Unterbrüche,
      Eingriffe unbefugter Dritter, etc.) verfälscht werden können. Die in der Dr. Blumer-Website enthaltenen Aussagen
      und
      Informationen werden von der B&P ausschliesslich für den privaten Gebrauch sowie für Informationszwecke
      bereitgestellt; sie können jederzeit und ohne vorherige Ankündigung geändert werden.</p>

    <h3 class="pt-4">Kein Angebot</h3>
    <p>Die in der Dr. Blumer-Website enthaltenen Aussagen und Informationen sind nicht als Angebot oder Empfehlung
      bestimmter Anlageprodukte zu verstehen. Hier enthaltene Aussagen und Informationen können eine auf die
      individuellen
      Verhältnisse des Anlegers abgestellte, anleger- und objektorientierte Beratung nicht ersetzen. Bitte setzen Sie
      sich
      gegebenenfalls mit einem Kundenberater der B&P in Verbindung.</p>

    <h3 class="pt-4">Performance</h3>
    <p>Der Anleger sollte sich bewusst sein, dass Kurse sowohl steigen als auch fallen können. Aus diesem Grunde ist
      eine
      positive Performance in der Vergangenheit keine Garantie für eine positive Performance in der Zukunft. Ausserdem
      unterliegen Anlagen in Fremdwährungen Währungskursschwankungen.</p>

    <h3 class="pt-4">Haftungsbeschränkung</h3>
    <p>Jegliche Haftung (einschliesslich für Fahrlässigkeit) der B&P für Kosten oder Schäden irgendwelcher Art
      (einschliesslich direkte und indirekte Schäden, immaterielle Schäden sowie Folgeschäden), die sich aus oder im
      Zusammenhang mit dem Zugriff auf die Dr. Blumer-Website oder deren Benutzung (bzw. aus der Unmöglichkeit des
      Zugriffs oder der Benutzung) ergeben oder die aus oder im Zusammenhang mit der Verknüpfung (linking) mit anderen
      Websites entstehen, ist ausgeschlossen. Dies gilt auch wenn die B&P auf die Möglichkeit solcher Schäden
      hingewiesen
      wurde.</p>

    <h3 class="pt-4">Verknüpfte Websites</h3>
    <p>Die Dr. Blumer-Website kann Verknüpfungen (Links) zu Websites von Dritten enthalten, auf deren Inhalt die B&P
      keinen
      Einfluss und die sie nicht geprüft hat. Die B&P übernimmt für deren Benutzung und für deren Inhalte, den darauf
      angebotenen Produkten, Dienstleistungen oder sonstigen Angeboten keine Verantwortung. Gleiches gilt für
      Websites,
      die Links auf die Dr. Blumer-Website anbieten. Zudem ist für einen Link, der von einer fremden Website auf die
      Dr.
      Blumer-Website führt, stets vorgängig eine ausdrückliche Bewilligung von der B&P einzuholen. Beim Zugriff auf
      die
      Webseiten der VVGes oder bei der elektronischen Kontaktaufnahme mit der VVGes werden die Daten des Besuchers
      grundsätzlich über ein offenes, für jedermann zugängliches Netz transportiert. Die Daten werden bei der
      Kommunikation auch grenzüberschreitend übermittelt. Dies gilt auch für eine Datenübermittlung, bei der sich
      Sender
      und Empfänger im selben Staat befinden.</p>

    <h3 class="pt-4">Google Analytics</h3>
    <p>Die Dr. Blumer-Website benutzt Google Analytics, einen Webanalysedienst der Google Inc. („Google“). Google
      Analytics
      verwendet sog. „Cookies“, Textdateien, die auf Ihrem Computer gespeichert werden und die eine Analyse der
      Benutzung
      der Dr. Blumer-Website durch Sie ermöglichen. Die durch den Cookie erzeugten Informationen über Ihre Benutzung
      diese
      Website (einschliesslich Ihrer IP-Adresse) wird an einen Server von Google in den USA übertragen und dort
      gespeichert. Google wird diese Informationen benutzen, um Ihre Nutzung der Dr. Blumer-Website auszuwerten, um
      Reports über die Websiteaktivitäten für die Websitebetreiber zusammenzustellen und um weitere mit der
      Websitenutzung
      und der Internetnutzung verbundene Dienstleistungen zu erbringen. Auch wird Google diese Informationen
      gegebenenfalls an Dritte übertragen, sofern dies gesetzlich vorgeschrieben oder soweit Dritte diese Daten im
      Auftrag
      von Google verarbeiten. Google wird Ihre IP-Adresse nicht mit anderen Daten der Google in Verbindung bringen.
      Sie
      können die Installation der Cookies durch eine entsprechende Einstellung Ihrer Browser Software verhindern; wir
      weisen Sie jedoch darauf hin, dass Sie in diesem Fall gegebenenfalls nicht sämtliche Funktionen der Dr.
      Blumer-Website voll umfänglich nutzen können. Durch die Nutzung der Dr. Blumer-Website erklären Sie sich mit der
      Bearbeitung der über Sie erhobenen Daten durch Google in der zuvor beschriebenen Art und Weise und zu dem zuvor
      benannten Zweck einverstanden.</p>

    <h3 class="pt-4">E-mail</h3>
    <p>Die Benutzung von E-mail und elektronischen Formularen birgt Gefahren in sich. Es kann folglich nicht
      ausgeschlossen
      werden, dass auf diese Weise gesendete Daten von Dritten eingesehen und Kontaktaufnahmen zu unserem Unternehmen
      nachvollzogen werden können. Entsprechend empfehlen wir, für die Übermittlung von Kundendaten und Aufträgen für
      geschäftliche Vorgänge dieses Medium nicht zu verwenden. Falls wir eine E-Mail erhalten und nicht ausdrücklich
      anderweitig instruiert werden, nehmen wir an, dass es uns erlaubt ist mittels E-Mail zu antworten und auch
      weiterhin
      via E-Mail zu kommunizieren. Wir behalten uns vor E-Mails mit potentiell gefährlichen Datenanlagen
      abzuweisen.</p>


    <h3 class="pt-4">Rechtswirksamkeit</h3>
    <p>Diese Benutzungsbedingungen und rechtlichen Informationen sind als Teil des Internetangebotes zu betrachten,
      von
      dem
      aus auf diese Seiten verwiesen wurde. Sofern Teile oder einzelne Formulierungen dieses Textes der geltenden
      Rechtslage nicht, nicht mehr oder nicht vollständig entsprechen sollte, bleiben die übrigen Teile des Dokumentes
      in
      ihrem Inhalt und ihrer Gültigkeit davon unberührt.</p>

  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()" class="bp-button">Abbrechen</button>
    <button mat-button class="bp-button" [mat-dialog-close]="true" cdkFocusInitial>Akzeptieren</button>
  </mat-dialog-actions>
}
@if (currentLanguage === 'en') {

  <h2 mat-dialog-title>Disclaimer / Legal information</h2>
  <mat-dialog-content>

    <p>Welcome to the website of Dr. Blumer&Partner Asset-Management (hereinafter referred to as «B&P»). Please read
      the following terms and conditions - which have been drawn up at the instigation of our legal advisors -
      carefully. By accessing this website and its pages (hereinafter referred to as the «Dr. Blumer website»), you
      declare that you have understood and accept the following terms of use and legal information in connection with
      the Dr. Blumer website. If you do not agree with the following conditions, please refrain from accessing the Dr.
      Blumer website.</p>

    <h3 class="pt-4">Terms of use and legal information</h3>

    <h3 class="pt-4">Local legal restrictions</h3>
    <p>Foreign jurisdictions may prohibit the publication of the Dr. Blumer website or access to the Dr. Blumer
      website. Persons who are subject to such restrictions may therefore not visit the Dr. Blumer website.
      Restrictions apply in particular to citizens of the United States of America (U.S.A.) and the United Kingdom
      (UK) and to persons resident in the U.S.A. or UK.</p>

    <h3 class="pt-4">Rights to the Dr. Blumer website</h3>
    <p>The entire content of the Dr. Blumer website is protected by copyright (all rights reserved). Downloading or
      printing out individual pages and/or sections of the Dr. Blumer website is permitted, provided that neither the
      copyright notices nor other legally protected designations are removed. If you download software or data from
      the Dr. Blumer website or reproduce it in any other way, B&P retains all ownership rights. No part of the
      Dr. Blumer website is designed in such a way as to grant a license or right to use an image, a registered
      trademark or a logo. Downloading or copying the Dr. Blumer website does not transfer any rights to you with
      regard to the software or elements on the Dr. Blumer website. B&P reserves all rights (in particular
      copyright and trademark rights) in respect of all elements on the Dr. Blumer website. The (complete or partial)
      reproduction, transmission (electronically or by other means), modification, linking or use of the Dr. Blumer
      website for public or commercial purposes is prohibited without the prior written consent of B&P.</p>

    <h3 class="pt-4">No assurances or guarantees</h3>
    <p>All statements and information contained on the Dr. Blumer website have been carefully researched and checked
      by the Dr. Blumer&Partner Group or third parties at the time of publication. However, neither B&P nor third
      parties can give any explicit or implicit assurance or guarantee (including liability) for the accuracy,
      completeness and up-to-dateness of the information. B&P can also give no assurance that the statements and
      information cannot be falsified by technical faults (transmission errors, technical defects, interruptions,
      interference by unauthorized third parties, etc.). The statements and information contained in the Dr. Blumer
      website are provided by B&P exclusively for private use and for information purposes; they may be changed at any
      time and without prior notice.</p>

    <h3 class="pt-4">No offer</h3>
    <p>The statements and information contained on the Dr. Blumer website are not to be understood as an offer or
      recommendation of specific investment products. The statements and information contained herein cannot replace
      investor- and object-oriented advice based on the individual circumstances of the investor. If necessary, please
      contact a B&P client advisor.</p>

    <h3 class="pt-4">Performance</h3>
    <p>Investors should be aware that prices can fall as well as rise. For this reason, a positive performance in the
      past is no guarantee of a positive performance in the future. In addition, investments in foreign currencies are
      subject to exchange rate fluctuations.</p>

    <h3 class="pt-4">Limitation of liability</h3>
    <p>Any liability (including for negligence) of B&P for costs or damages of any kind (including direct and indirect
      damages, immaterial damages and consequential damages) arising from or in connection with access to the Dr.
      Blumer website or its use (or from the impossibility of access or use) or arising from or in connection with the
      linking to other websites is excluded. This also applies if B&P has been made aware of the possibility of such
      damages.</p>

    <h3 class="pt-4">Linked websites</h3>
    <p>The Dr. Blumer website may contain links to websites of third parties over whose content B&P has no influence
      and which it has not checked. B&P accepts no responsibility for their use or for their content, products,
      services or other offers. The same applies to websites that offer links to the Dr. Blumer website. In addition,
      express permission must always be obtained in advance from B&P for a link that leads from a third-party
      website to the Dr. Blumer website. When accessing the VVGes website or contacting the VVGes electronically, the
      visitor's data is generally transmitted via an open network that is accessible to everyone. The data is also
      transmitted across borders during communication. This also applies to data transmission where the sender and
      recipient are located in the same country.</p>

    <h3 class="pt-4">Google Analytics</h3>
    <p>The Dr. Blumer website uses Google Analytics, a web analytics service provided by Google Inc (“Google”). Google
      Analytics uses “cookies”, which are text files placed on your computer, to help the Dr. Blumer website analyze
      how users use the site. The information generated by the cookie about your use of the website (including your IP
      address) will be transmitted to and stored by Google on servers in the United States. Google will use this
      information for the purpose of evaluating your use of the Dr. Blumer website, compiling reports on website
      activity for website operators and providing other services relating to website activity and internet usage.
      Google may also transfer this information to third parties where required to do so by law, or where such third
      parties process the information on Google's behalf. Google will not associate your IP address with any other
      data held by Google. You can prevent the installation of cookies by selecting the appropriate settings in your
      browser software; However, we would like to point out that in this case you may not be able to use all functions
      of the Dr. Blumer website to their full extent. By using the Dr. Blumer website, you consent to the processing
      of data about you by Google in the manner and for the purposes set out above.</p>

    <h3 class="pt-4">E-mail</h3>
    <p>The use of e-mail and electronic forms involves risks. Consequently, it cannot be ruled out that data sent in
      this way can be viewed by third parties and that contact with our company can be traced. Accordingly, we
      recommend that you do not use this medium for the transmission of customer data and orders for business
      transactions. If we receive an e-mail and are not expressly instructed otherwise, we assume that we are
      permitted to reply by e-mail and to continue to communicate by e-mail. We reserve the right to reject e-mails
      with potentially dangerous data attachments.


    <h3 class="pt-4">Legal validity</h3>
    These terms of use and legal information are to be regarded as part of the website from which you were referred to
    these pages. If sections or individual terms of this statement are not legal or correct, the content or validity
    of the other parts remain uninfluenced by this fact.

  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()" class="bp-button">Cancel</button>
    <button mat-button class="bp-button" [mat-dialog-close]="true" cdkFocusInitial>Accept</button>
  </mat-dialog-actions>
}
